import * as React from 'react';
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from '../base';

interface NoddiOtpProps {
  maxLength?: number;
  onChange?: (value: string) => void;
  value?: string;
  placeholder?: string;
}

const groupSize = 3;

export const NoddiOtp = React.forwardRef<HTMLInputElement, NoddiOtpProps>(
  ({ maxLength = 6, onChange, value, placeholder }, ref) => {
    const numberOfGroups = Math.ceil(maxLength / groupSize);

    return (
      <div className='flex w-full flex-col gap-3'>
        {placeholder && <p className='text-sm'>{placeholder}</p>}
        <InputOTP
          ref={ref}
          maxLength={maxLength}
          pattern='[0-9]*'
          type='tel'
          inputMode='numeric'
          onChange={onChange}
          value={value}
        >
          {Array.from({ length: numberOfGroups }, (_, groupIndex) => {
            const startIndex = groupIndex * groupSize;
            const endIndex = Math.min(startIndex + groupSize, maxLength);
            const groupLength = endIndex - startIndex;

            return (
              <React.Fragment key={groupIndex}>
                <InputOTPGroup key={groupIndex}>
                  {Array.from({ length: groupLength }, (_, index) => (
                    <InputOTPSlot key={startIndex + index} index={startIndex + index} />
                  ))}
                </InputOTPGroup>
                {groupIndex < numberOfGroups - 1 && <InputOTPSeparator />}
              </React.Fragment>
            );
          })}
        </InputOTP>
      </div>
    );
  }
);

NoddiOtp.displayName = 'NoddiOtp';
